var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "contents",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:red;}"), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath855"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,800 H 800 V 0 H 0 Z",
    id: "path853"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, "\u30A2\u30FC\u30C8\u30DC\u30FC\u30C9 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 75,
    height: 75,
    rx: 11.338583,
    id: "rect8",
    x: 0,
    y: 0,
    ry: 11.338583,
    style: {
      fill: "#808080",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g851",
    clipPath: "url(#clipPath855)",
    transform: "matrix(0.07834116,0,0,-0.0763578,5.6396953,69.438781)",
    style: {
      strokeWidth: 17.2392
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g933",
    transform: "matrix(1.3362295,0,0,1.3145126,-152.82854,-36.272771)",
    style: {
      strokeWidth: 13.0075
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g943"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 596.2979,261.5898 c -20.337,-20.336 -43.898,-36.133 -70.029,-46.947 -9.548,-3.951 -19.267,-7.168 -29.108,-9.643 l -6.787,-89.502 h 127.307 l -11.847,156.264 c -3.053,-3.465 -6.224,-6.861 -9.536,-10.172",
    style: {
      fill: "#231916",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 13.0075
    },
    id: "path867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 595.874,521.0225 -0.022,-0.021 c -0.179,0.194 -0.352,0.396 -0.54,0.583 -19.45,19.452 -77.105,-5.519 -137.627,-56.794 l 21.204,-18.556 c 17.749,14.776 35.482,27.392 51.964,36.862 18.642,10.71 31.152,14.809 38.365,16.361 1.109,0.24 2.263,-0.101 3.066,-0.902 0.804,-0.803 1.141,-1.956 0.903,-3.064 -1.553,-7.215 -5.654,-19.726 -16.361,-38.367 -15.779,-27.461 -40.276,-58.391 -68.976,-87.089 -28.7,-28.7 -59.627,-53.197 -87.088,-68.974 -18.64,-10.711 -31.152,-14.811 -38.366,-16.362 -1.108,-0.237 -2.263,0.099 -3.065,0.904 -0.801,0.803 -1.142,1.955 -0.903,3.063 1.553,7.212 5.652,19.726 16.361,38.366 9.885,17.202 23.19,35.764 38.807,54.288 l -18.536,21.181 c -52.596,-61.356 -78.456,-120.23 -58.758,-139.929 0.496,-0.496 1.024,-0.951 1.568,-1.387 67.438,-60.236 173.483,-53.049 242.681,16.149 69.263,69.263 75.737,176.26 15.323,243.688",
    style: {
      fill: "#231916",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 13.0075
    },
    id: "path871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 489.7236,407.1621 -78.596,66.676 c 1.284,9.041 -1.549,18.555 -8.503,25.511 -11.74,11.74 -30.774,11.74 -42.514,0 -11.74,-11.74 -11.74,-30.773 0,-42.513 7.205,-7.205 17.156,-9.98 26.484,-8.341 l 66.249,-78.212 z",
    style: {
      fill: "#231916",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 13.0075
    },
    id: "path875"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 29.2669,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 210.02485,566.33472 C 317.00301,457.07644 320.29463,452.03376 320.29463,452.03376",
    id: "path921"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 29.2669,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 320.46768,565.7056 C 210.91792,453.49309 210.91792,453.49309 210.91792,453.49309",
    id: "path923"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnection);
export default __webpack_public_path__ + "static/media/Disconnection.1b2a20003cf8db3153a57aead6f1a531.svg";
export { ForwardRef as ReactComponent };